function updateFreeShipping() {
  var container = document.querySelector('.free-shipping-progress');
  if (!container) return;

  var threshold = parseInt(container.dataset.threshold, 10);
  var currency = container.dataset.currency || '€';
  
  var totalEl = document.querySelector('#CartDrawer .totals__total-value') ||
                  document.querySelector('.drawer__footer .totals__total-value') ||
                  document.querySelector('.totals__total-value');
  
  if (!totalEl) return;
  
  var totalText = totalEl.textContent.replace(/[^\d.,]/g, '');
  var totalCents = Math.round(parseFloat(totalText.replace(',', '.')) * 100);
  
  var remaining = threshold - totalCents;
  var percentage = Math.min(100, Math.max(0, (totalCents / threshold) * 100));
  
  var fillBar = container.querySelector('.progress-fill');
  var messageEl = container.querySelector('.progress-message');
  var successEl = container.querySelector('.progress-success');
  var remainingEl = container.querySelector('.remaining-amount');
  
  if (fillBar) fillBar.style.width = percentage + '%';
  
  if (remaining <= 0) {
    if (messageEl) messageEl.style.display = 'none';
    if (successEl) successEl.style.display = 'block';
  } else {
    if (messageEl) messageEl.style.display = 'block';
    if (successEl) successEl.style.display = 'none';
    if (remainingEl) remainingEl.textContent = currency + Math.ceil(remaining / 100);
  }
}

// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateFreeShipping);
} else {
  updateFreeShipping();
}

// Listen for all possible cart update events
document.addEventListener('cart:updated', updateFreeShipping);
document.addEventListener('cart:change', updateFreeShipping);
document.addEventListener('theme:cart:change', updateFreeShipping);

// Critical: Listen for section reloads (this is what Dawn uses)
document.addEventListener('shopify:section:load', function(event) {
  // Only update if it's a cart-related section
  if (event.detail && event.detail.sectionId && event.detail.sectionId.includes('cart')) {
    setTimeout(updateFreeShipping, 50);
    setTimeout(updateFreeShipping, 200);
  } else {
    setTimeout(updateFreeShipping, 50);
  }
});

// Watch for fetch requests (AJAX cart updates)
if (window.fetch) {
  var originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(function(response) {
      if (response.url && response.url.includes('/cart')) {
        setTimeout(updateFreeShipping, 100);
      }
      return response;
    });
  };
}
